import styled from 'styled-components';

export const AmountEditorStyled = styled.div`
    label {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        color: rgba(255, 255, 255, 0.6);

        .at {
            color: #8192E4;
            padding: 8px 0;
            font-weight: 600;
        }
    }

    .amount-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 8px;

        /* Chrome, Safari, Edge, Opera */

        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Firefox */

        input[type=number] {
            -moz-appearance: textfield;
        }

        .amount {
            display: inline-block;
            font-size: 28px;
            font-weight: 600;
            color: var(--color-white-60);
        }
        .editable {
            display: inline;
            color: #FFFFFF;
            
            &:focus {
                outline: none;
            }
        }
    }
`;

export const AmountEditorButtonsContainerStyled = styled.div.attrs(({ big }) => ({ className: big ? 'big' : '' }))`
    display: flex;
    flex-direction: row;
    gap: 8px;
    user-select: none;
    overflow: auto;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
        display: none;
    }
    
    svg {
        fill: #FFFFFF;
    }

    > * {
        text-align: center;
        flex: 1;
        background: rgba(129, 146, 228, 0.1);
        color: rgba(255, 255, 255, 0.6);
        border-radius: 12px;
        padding: 12px;
        cursor: default;
    }

    &.big {
        font-size: 18px;
    }
    & .preset-button {
        width: 48px;
    }
`;

export const AmountEditorDescriptionStyled = styled.div`
    color: var(--color-white-60);
    font-size: 14px;
    font-weight: 400;
    margin-top: 12px;
`;

export const AmountEditorErrorStyled = styled.div`
    color: var(--color-red);
    font-size: 14px;
    font-weight: 400;
    margin-top: 12px;
`;
